"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRIDGE_JOB_TYPE = void 0;
var BRIDGE_JOB_TYPE;
(function (BRIDGE_JOB_TYPE) {
    BRIDGE_JOB_TYPE["FETCH_ALL"] = "FETCH_ALL";
    BRIDGE_JOB_TYPE["FETCH_USER"] = "FETCH_USER";
})(BRIDGE_JOB_TYPE = exports.BRIDGE_JOB_TYPE || (exports.BRIDGE_JOB_TYPE = {}));
